import type { ISOTimestampString } from '../people/types';
import type { PeopleRoleKey, PeopleAccess } from './access';
import type { State } from './types';

export type Mutation = {
  type: 'setAccessPolicy';
  data: {
    data: Record<PeopleRoleKey, PeopleAccess>;
    updated_at?: ISOTimestampString;
    updated_by?: string;
  };
};

export function reducer(state: State, action: Mutation) {
  switch (action.type) {
    case 'setAccessPolicy':
      return setAccessPolicy(state, action);
    default:
      return state;
  }
}

function setAccessPolicy(
  _state: State,
  {
    data,
  }: {
    data: {
      data: Record<PeopleRoleKey, PeopleAccess>;
      updated_at?: ISOTimestampString;
      updated_by?: string;
    };
  },
): State {
  return {
    data: data.data,
    updated_at: data.updated_at,
    updated_by: data.updated_by,
    loaded: true,
  };
}
